<template>
  <BasicModal
    :footer="null"
    extClass="LockModal"
    :title="t('layout.header.lockScreen')"
    v-bind="$attrs"
    :class="'LockModal'"
    @register="register"
  >
    <div :class="`${prefixCls}__entry`">
      <div :class="`${prefixCls}__header`">
        <img :src="avatarImg" :class="`${prefixCls}__header-img`" />
        <p :class="`${prefixCls}__header-name`"> {{ getRealName }} </p>
      </div>

      <!-- <BasicForm @register="registerForm" /> -->

      <div :class="`${prefixCls}__entry`">
        锁屏密码为账号密码，如果忘记密码，请联系管理员重置密码
      </div>

      <div :class="`${prefixCls}__footer`">
        <a-button type="primary" block class="mt-2" @click="handleLock">
          {{ t('layout.header.lockScreenBtn') }}
        </a-button>
      </div>
    </div>
  </BasicModal>
</template>
<script lang="ts">
  import { defineComponent, computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useDesign } from '@/hooks/web/useDesign';
  import { BasicModal, useModalInner } from '@/components/Modal/index';
  import { BasicForm, useForm } from '@/components/Form/index';
  import { useUserStore } from '@/store/modules/user';
  import { useLockStore } from '@/store/modules/lock';
  import headerImg from '@/assets/images/header.jpg';
  // import SysConfigUtils from '@/utils/sysConfigUtils';
  import { showAvatra } from 'xmgoing-utils';

  export default defineComponent({
    name: 'LockModal',
    components: { BasicModal, BasicForm },

    setup() {
      const { t } = useI18n();
      const { prefixCls } = useDesign('header-lock-modal');
      const userStore = useUserStore();
      const lockStore = useLockStore();
      //用户头像
      const avatarImg = computed(() => {
        return showAvatra(userStore.getUserInfo.avatar);
        // return (
        //   SysConfigUtils.go_eplat_adress +
        //   '/api/pe-attachment/attachment/showImg/' +
        //   userStore.getUserInfo.avatar
        // );
      });

      const getRealName = computed(() => userStore.getUserInfo?.realName);
      const [register, { closeModal }] = useModalInner();

      const [registerForm, { validateFields, resetFields }] = useForm({
        showActionButtonGroup: false,
        // schemas: [
        //   {
        //     field: 'password',
        //     label: t('layout.header.lockScreenPassword'),
        //     colProps: {
        //       span: 24,
        //     },
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入'+t('layout.header.lockScreenPassword'),
        //       },
        //     ],
        //     componentProps: {
        //       placeholder: t('layout.header.lockScreenPassword'),
        //     },
        //     component: 'InputPassword',
        //     required: true,
        //   },
        // ],
      });

      async function handleLock() {
        // const values = (await validateFields()) as any;
        // const password: string | undefined = values.password;
        closeModal();

        lockStore.setLockInfo({isLock: true,pwd: '123',});
        // await resetFields();
      }

      const avatar = computed(() => {
        const { avatar } = userStore.getUserInfo;
        return avatar || headerImg;
      });

      return {
        t,
        avatarImg,
        prefixCls,
        getRealName,
        register,
        registerForm,
        handleLock,
        avatar,
      };
    },
  });
</script>
<style lang="less">
  @prefix-cls: ~'@{namespace}-header-lock-modal';

  .fullscreen-modal {
    .LockModal.ant-modal {
      width: 100% !important;
    }
    .ant-modal {
      top: 0 !important;
    }
  }
  .LockModal {
    .ant-modal-close-x {
      display: inline-block;
      width: 96px;
      height: 56px;
      line-height: 56px;
    }
  }
  .@{prefix-cls} {
    &__entry {
      position: relative;
      //height: 240px;
      padding: 30px;
      border-radius: 10px;
    }

    &__header {
      width: auto;
      text-align: center;

      &-img {
        width: 70px;
        height: 70px;
        border-radius: 50%;
      }

      &-name {
        margin-top: 5px;
      }
    }

    &__footer {
      text-align: center;
    }
  }
</style>
